import datas from './datas.json';

export default class CategorieProduitService {
    getAllDefaultCodeValue() {
        var retour = {};
        if (datas != null) {
            datas.forEach(j =>
                retour[j["categorieProduitCode"]] = JSON.parse(j["categorieProduitDefaultValue"])
            );
        }
        return retour;
    }
}


// WEBPACK FOOTER //
// ./src/services/categorieProduit/CategorieProduitService.js